import Button from 'components/Button';
import CloseIcon from 'assets/icons/close.svg';
import CustomModal from 'components/CustomModal';
import { RootState, useAppSelector } from 'store';
import CloseWhiteIcon from 'assets/icons/close-white.svg';
import checkmark from 'assets/icons/checkmark-with-texture.svg';

interface ConfirmPortCoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ConfirmPortCoModal = ({ isOpen, onClose }: ConfirmPortCoModalProps) => {
  const isReviewed = useAppSelector(
    (state: RootState) => state.portCoData.isDataReviewed
  );

  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      className='flex flex-col gap-4 max-w-[480px] p-8 rounded-2xl overflow-hidden'
    >
      <img
        alt='Close'
        onClick={onClose}
        src={isDarkMode ? CloseWhiteIcon : CloseIcon}
        className='cursor-pointer absolute top-4 right-4'
      />

      <img src={checkmark} alt='checkmark' className='w-20 h-20' />

      <p className='font-semibold text-[28px]'>
        {isReviewed ? 'Data updated successfully!' : 'Data updated!'}
      </p>

      <p className='font-light text-base text-[#5C5C5C]'>
        Thank you very much! Your data is now available to generate analysis
        reports.
      </p>

      <Button
        id='ok'
        label='Ok'
        onClick={onClose}
        className='w-full mt-6 px-5 py-2 rounded-5xl text-lg font-light text-center text-white bg-black dark:bg-white dark:text-black hover:bg-[#404040] dark:hover:bg-gray-400 transition-all duration-300'
      />
    </CustomModal>
  );
};

export default ConfirmPortCoModal;
